import { Stack, Typography } from "@mui/material";
import './loading.css';

const Loading = ({
    label="Loading..."
}) => {
    return (
        <>
            <Stack
                justifyContent='center'
                alignItems='center'
                height='100vh'
            >
                <img
                    src="logo512.png" 
                    alt="loading-icon"
                    style={{
                        width: '100px',
                        height: '100px',
                        animation: 'bounce 0.75s infinite linear'
                    }}
                />

                <Typography
                    fontWeight={600}
                    mt={1.5}
                    color="#666666"
                    fontSize={12}
                >
                    {label}
                </Typography>
            </Stack>
        </>
    );
}

export default Loading;